// extracted by mini-css-extract-plugin
export default {"profile_avatar":"ProfileAvatar_profile_avatar__adHxa","shimmer":"ProfileAvatar_shimmer__6NG2r"};